import { Column } from 'primereact/column'
import { DataTable } from 'primereact/datatable'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { tableCellCentered } from '../../../../../assets/js/styles'
import { CustomModal } from '../../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../../store/actions/system.actions'
import useModalResumoPrestacaoContas, { LOAD_MESSAGE } from './ModalResumoPrestacaoContasHook'

function ModalResumoPrestacaoContas({ dispatch, onResponse, modal }) {
  const { state, localDispatch } = useModalResumoPrestacaoContas()

  useEffect(() => {
    if (modal.show) localDispatch.onInit(modal.data)
  }, [modal.show])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET_PRESTACOES:
        dispatch(showLoadingBox('Aguarde...', 'Adquirindo dados'))
        localDispatch.getPrestacoesContas(state.selectedMovimentacao.id)
        break

      case LOAD_MESSAGE.SUCCESS:
        dispatch(hideLoadingBox())
        localDispatch.buildData(state.selectedMovimentacao.ativos, state.prestacoes)
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  return (
    <>
      <CustomModal
        isVisible={modal.show}
        header={'Resumo da Prestação de Contas'}
        width={600}
        onClose={() => onResponse('close', null)}
      >
        <div className="p-grid">
          <DataTable
            value={state.data}
            emptyMessage={'Não existe movimentação para o Período selecionado'}
            paginator={true}
            rows={10}
          >
            <Column field={'ativo_name'} header={'Ativo'} />
            <Column field={'qte_delivery'} header={'Qte. Enviada'} style={tableCellCentered(90)} />
            <Column field={'qte_fisico'} header={'Qte. Fisico'} style={tableCellCentered(90)} />
            <Column field={'qte_canhoto'} header={'Qte. Canhoto'} style={tableCellCentered(90)} />
          </DataTable>
        </div>
      </CustomModal>
    </>
  )
}

export default connect()(ModalResumoPrestacaoContas)
